import React from 'react';

import Button from '../../library/button/button';

import { useModal } from '../../shared/hooks/hooks';

import { isCanonicalProduct } from '../../shared/utils/product/product';

import { ProductItem } from '../../shared/types/product';
import * as MODAL_TYPES from '../../shared/constants/modals';

import './found-it-lower-button.scss';

interface FoundItLowerButtonProps {
  analyticsPrefix?: string;
  className?: string;
  productItem: ProductItem;
}

function FoundItLowerButton(props: FoundItLowerButtonProps) {
  const { analyticsPrefix = '', className, productItem } = props;
  const { product } = productItem || {};

  const { openModal } = useModal();

  const isCanonical = isCanonicalProduct(product);
  const { mapDisplayRule, mapRuleSatisfied } = product || {};

  if (isCanonical || (mapRuleSatisfied && !mapDisplayRule?.mapPriceDisplay)) {
    return null;
  }

  return (
    <Button
      className={`${className || ''} found-it-lower-button`}
      onClick={() => {
        openModal(MODAL_TYPES.FOUND_IT_LOWER_DRAWER, {
          analyticsPrefix,
          productItem: productItem
        });
      }}
      styleName="found-it-lower"
    >
      found it lower?
    </Button>
  );
}

export default FoundItLowerButton;
